
/**
 * Entry point for the customer service
 * part.
 */

import feedback          from './elements/feedback/feedback';
import faq               from './modules/faq';
import faqSearch         from './modules/faq/faq-search';
import faqNoSearch         from './modules/faq/faq-no-search';
import queueTime         from './modules/queue-time/queue-time';
import app               from '../shared/shared';

app.registerModules([
    feedback,
    faq,
    faqSearch,
    faqNoSearch,
    queueTime
]);